<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="查询" name="query">
        <query-list ref="queryList">
          <template slot="toolbar-right">
            <el-button type="primary" plain @click="onExport">导出</el-button>
          </template>
        </query-list>
      </el-tab-pane>
      <el-tab-pane label="统计" name="grade">
        <el-form class="query-form">
          <!-- <el-form-item label="查询学期" :style="isMB?'margin-left: 10px;':''">
            <el-select v-model="termId" size="mini" @change="setSection">
              <template v-for="(i,index) in terms">
                <el-option :key="index" :value="i.TermId" :label="i.TermName"></el-option>
              </template>
            </el-select>
          </el-form-item>-->
          <el-form-item label="查询时间" style="margin-left: 10px;">
            <el-date-picker
              size="mini"
              :clearable="false"
              v-model="params.date"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="当前节次" style="margin-left: 10px;">
            <el-select v-model="params.section" size="mini">
              <template v-for="(i,index) in sections">
                <el-option :key="index" :value="i.SectionId" :label="i.SectionName"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <div :style="isMB?'margin-left: 10px;':'line-height: 40px;margin-left: 10px;'">
            <el-button size="mini" type="primary" icon="el-icon-search" @click="reload">搜索</el-button>
          </div>
        </el-form>
        <grade-info v-show="Lv=='grade'" ref="gradeInfo" @to-class="toClass" />
        <class-info v-show="Lv=='class'" ref="classInfo" @return-up="return_up" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import gradeInfo from "@/components/at/statistics/grade";
import classInfo from "@/components/at/statistics/class";
import queryList from "@/components/at/statistics/query";

export default {
  name: "statistics",
  components: {
    gradeInfo,
    classInfo,
    queryList,
  },
  data() {
    return {
      tabName: "query",
      section_api: require("@/api/ed/section").default,
      term_api: require("@/api/ed/term").default,
      params: {
        date: this.$commonJs.toDateString(new Date()),
        section: 1,
        gradeId: 0,
      },
      termId: 0,
      isMB: this.$store.state.isMB,
      terms: [], //学期列表
      sections: [], //课程节次列表
      Lv: "grade", //grade：年级；class：班级
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.queryList.onExport();
        })
        .catch(() => {});
    },
    handleClick() {
      if (this.tabName == "grade") {
        this.Lv = "grade";
        this.$refs["gradeInfo"].clear();
        this.$refs["classInfo"].clear();
        this.init();
      } else {
        this.reload();
      }
    },
    setSection() {
      this.sections = [];
      for (let i = 1; i <= 10; i++) {
        this.sections.push({
          SectionId: i,
          SectionName: "第" + i + "节课",
        });
      }
      this.params.section = this.sections[0].SectionId;
      this.reload();
      // this.section_api.list({ TermId: this.termId }).then((res) => {
      //   console.log("sections", res);
      //   if (res.Data != null && res.Data.length > 0) {
      //     this.sections = res.Data;
      //     this.params.section = this.sections[0].SectionId;
      //   }
      // });
    },
    init() {
      this.term_api.list().then((res) => {
        this.terms = res.Data;
        if (this.terms.length > 0) {
          this.termId = this.terms[0].TermId;
          this.setSection();
        }
      });
    },
    reload() {
      if (this.tabName == "grade") {
        console.log("reload", this.params);
        this.$refs[this.Lv + "Info"].query(this.params);
      } else {
        this.$refs["queryList"].setParams();
      }
    },
    toClass(data) {
      console.log("To班级", data);
      this.Lv = "class";
      this.params.gradeId = data.GradeId;
      this.reload();
    },
    return_up() {
      this.Lv = "grade";
      this.reload();
      this.$refs["classInfo"].clear();
    },
  },
};
</script>
<style lang="scss" >
.query-form {
  @media screen and (min-width: 768px) {
    display: flex;
    display: -webkit-flex;
  }
  .el-form-item {
    display: flex;
    margin-bottom: 20px;
    @media screen and (max-width: 767px) {
      margin-bottom: 5px;
    }
    .el-form-item__label {
      width: 70px;
      float: left;
      text-align: left;
    }
    .el-date-editor.el-input {
      width: 180px;
    }
    .el-select {
      width: 180px;
    }
    .el-input {
      width: 180px;
    }
  }
}
</style>